import {Observable} from 'rxjs';

import {Injectable} from '@angular/core';
import {ApiService} from '@core/api/data-access';

@Injectable({
	providedIn: 'root',
})
export class AgentService {
	/* ------------------------------------------  Types and Constants ------------------------------------------ */

	/* ------------------------------------------ PROVIDERS / SERVICES ------------------------------------------ */

	/* ------------------------------------------------  Constructor ------------------------------------------------ */
	constructor(private apiService: ApiService) {}

	/* ------------------------------------------------  Methods ------------------------------------------------ */
	public restoreAgentDownload(cycleid: string, code: string): Observable<void> {
		return this.apiService.post<void, void>(`Cron/agent`, undefined, undefined, {
			cycleid,
			code,
		});
	}
}
